let subscription_1 = null
let subscription_2 = null

export function unsubscribeScrolls() {
  subscription_1?.()
  subscription_2?.()
  subscription_1 = null
  subscription_2 = null
}

export function subscribeScrolls() {
  unsubscribeScrolls()
  const id = 'questions-comments-container'
  const node = document.getElementById(id)
  if (!node) return
  const questionsNode = document.getElementById('questions-container')
  const commentsNode = document.getElementById('comments-container')
  if (!questionsNode) return
  const fun1 = event => {
    const scroll = questionsNode.scrollTop
    const containerNode = document.getElementById('comments-container')
    if (!containerNode) return
    containerNode.scrollTop = scroll
  }
  const fun2 = event => {
    const scroll = commentsNode.scrollTop
    const containerNode = document.getElementById('questions-container')
    if (!containerNode) return
    containerNode.scrollTop = scroll
  }
  questionsNode.addEventListener('scroll', fun1)
  subscription_1 = () => questionsNode.removeEventListener('scroll', fun1)
  commentsNode?.addEventListener('scroll', fun2)
  subscription_2 = () => commentsNode?.removeEventListener('scroll', fun2)
}

export function syncContainerScrolls() {
  const questionsNode = document.getElementById('questions-container')
  const commentsNode = document.getElementById('comments-container')
  if (!questionsNode || !commentsNode) return
  if (questionsNode.scrollTop !== commentsNode.scrollTop) {
    commentsNode.scrollTop = questionsNode.scrollTop
  }
}
